// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"in-z","badgeLink":"jn-z","category":"kn-z"};